export function isMessageInvalid(message: string | null | undefined): boolean {
    return !!message && message.length > 2000;
}
